import axios from 'axios'

const fetchPropertyActivityZoneListFilters = async ({ rootState }, { key, ...payload }) => {
    return await axios.post(`${rootState.baseURL}/properties/activityzones/list/filter/${key}/values`, payload, {})
  }

export default {
    fetchPropertyActivityZoneListFilters,
}
